<template>
	<div v-if="widgetReady">
		<div class="row">
			<div class="col-md-12">
				<h4>Basic Details</h4>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Name</label>
					<small><span class="redText">required</span></small>
					<input type="text" class="form-control" placeholder="Name" v-model="vm.name">
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Notes</label>
					<input type="text" class="form-control" placeholder="Description" v-model="vm.description">
				</div>
			</div>
		</div>
		<div class="row form-group">
			<div class="col-md-6">
				<div class="form-group">
					<label>Fee Category</label>
					<small><span class="redText">required</span></small>
					<select v-model="vm.feeCategory" class="form-control" :disabled="viewOnly">
						<option v-for="fe in feeCategorys" :value="fe.feeCategoryId">
							{{ fe.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Fee Type</label>
					<small><span class="redText">required</span></small>
					<select v-model="vm.feeTypeId" class="form-control" :disabled="viewOnly">
						<option v-for="ft in feeTypesFiltered" :value="ft.feeTypeId">
							{{ ft.name }}
						</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="alert alert-info">
					<i class="fa fa-lg fa-info-circle"></i>&nbsp;
					<span>{{ categoryDescription }}</span><br/>
					<span>{{ feeTypeDescription }}</span>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>Payment Type</label>
					<small><span class="redText">required</span></small>
					<select v-model="vm.strategyTypeId" :disabled="strategyTypesDisabled || viewOnly" class="form-control">
						<option v-for="st in strategyTypes" :value="st.strategyTypeId">
							{{ st.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label>{{ formulaLabel }}</label>
					<small><span class="redText">required</span></small>
					<input type="text" class="form-control" style="margin-bottom: 5px;"
						:placeholder="formulaLabel" v-model="vm.formula" :disabled="viewOnly">
					<small class="form-text text-muted">* Accresa transaction fees may apply</small>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {FeeFormClass} from "./FeeFormClass.js";
	import {configTables} from "../../../global/configTables.js";
	import _ from 'lodash'
	import {common} from "../../../global/common.js";
	import {api} from "../../../global/framework/api.js";

	export default {
		name: "FeeForm",
		props: {feeFormInstance: {type: [FeeFormClass], required: true}},
		data() {
			return {
				widgetReady: false,
				vm: {},
				feeCategorys: [
					{name: "Non-Stacked", feeCategoryId: 1, 
					description: "Non-Stacked Fee: Fee billed separately to the employer group. "},
					{name: "Stacked", feeCategoryId: 2, 
					description: "Stacked Fee: Fee added on top of the plan price and included in the final member price. "},
				],
				feeTypes: [],
				strategyTypes: [],
				viewOnly: true,
			};
		},
		computed: {
			feeCategoryId() {
				return this.vm && this.vm.feeCategory ? this.vm.feeCategory : 0;
			},
			categoryDescription() {
				let category = this.feeCategorys.find(x => x.feeCategoryId == this.vm.feeCategory);
				return category ? category.description : "";
			},
			feeTypesFiltered() {
				return this.feeTypes.filter(x => x.feeCategory == this.vm.feeCategory);
			},
			feeTypeId() {
				return this.vm && this.vm.feeTypeId ? this.vm.feeTypeId : 0;
			},
			feeTypeDescription() {
				let type = this.feeTypes.find(x => x.feeTypeId == this.vm.feeTypeId);
				return type ? type.description : "";
			},
			strategyTypesDisabled() {
				return !Boolean(this.feeCategoryId == 2);
			},
			formulaLabel() {
				if (!this.hasValue(this.vm)) {
					return "";
				}
				if (this.vm.strategyTypeId === common.PAYMENT_STRATEGY_TYPES.FIXED_FEE) {
					return "Fixed Amount";
				}
				if (this.vm.strategyTypeId === common.PAYMENT_STRATEGY_TYPES.PERCENTAGE) {
					return "Percentage";
				}
				return "Custom Formula"
			},
		},
		watch: {
			feeCategoryId(newValue) {
				// console.log("feeCategoryId newValue:", newValue);
				let filteredTypes = this.feeTypes.filter(x => x.feeCategory == newValue);
				let typeMatch = filteredTypes.find(x => x.feeTypeId == this.vm.feeTypeId);
				this.vm.feeTypeId = typeMatch ? typeMatch.feeTypeId : filteredTypes[0].feeTypeId;
				// console.log("feeCategoryId vm feeTypeId:", this.vm.feeTypeId);
				if (!Boolean(newValue == 2)) {
					this.vm.strategyTypeId = common.PAYMENT_STRATEGY_TYPES.FIXED_FEE;
				}
				// console.log("feeCategoryId vm strategyTypeId:", this.vm.strategyTypeId);
			},
		},
		async mounted() {
			let [template, ft, st] = await Promise.all([
				this.feeFormInstance.getTemplate(),
				this.feeFormInstance.getAllowedTypes(),
				configTables.getPaymentStrategyTypes()
			]);
			// console.log("template:", template);
			this.mapData('vm', template);
			this.viewOnly = template.strategyTypeId === common.PAYMENT_STRATEGY_TYPES.CUSTOM;
			this.feeTypes = ft;
			this.strategyTypes = st;
			this.vm.feeCategory = this.vm.feeCategory || 1;
			this.vm.feeTypeId = this.vm.feeTypeId || 1;
			this.vm.strategyTypeId = this.vm.strategyTypeId || 1;
			this.widgetReady = true;
		},
		methods: {
			async getFee() {
				let result = await api.postDataAsJson('Fee', 'ValidateStandAlone', this.vm, true);
				if (result) {
					return this.vm;
				}
				return null;
			}
		}
	}
</script>

<style scoped>

</style>